export enum ELanguage {
    EN = 'en',
    FR = 'fr',
    DE = 'de',
    RU = 'ru',
    KK = 'kk',
    UA = 'ua',
  }